import { render, staticRenderFns } from "./DataMinute.vue?vue&type=template&id=36cc011a"
import script from "./DataMinute.vue?vue&type=script&lang=js"
export * from "./DataMinute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports